import {Injectable} from '@angular/core';
import {ReplaySubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EventService {

  requestInProgress: Subject<boolean> = new ReplaySubject(10);

  private concurrentRequests = 0;

  constructor() {
    (window as any).NG_EVENT_SERVICE = this;
  }

  requestStarted() {
    if (this.concurrentRequests == 0) {
      this.requestInProgress.next(true);
    }
    this.concurrentRequests++;
  }

  requestFinished() {
    if (this.concurrentRequests == 1) {
      this.requestInProgress.next(false);
    }
    // More 'request finished' are generated by Knockout code than 'request started'
    this.concurrentRequests = Math.max(this.concurrentRequests - 1, 0);
  }
}
